import { Box, Typography } from '@mui/material';
import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { LineItem, Image } from 'components';

const CategoryDetails = ({ category }) => (
	<List>
		<LineItem label="Name" value={category && category.name} />
		<LineItem label="Value" value={category && category.value} />
		<LineItem label="Description" value={category && category?.description} />
		<LineItem label="Created At" value={category && category.created_at} />
	</List>
);

export default CategoryDetails;
